import React from 'react';
import {CreditInfo} from '../../models/creditInfo.model';
import {displayValue} from '../../../../Presentation/utils/displayUtils';

const getRatingColor = (rating: string | undefined) => {
  if (!rating) {
    return 'text-gray-600 bg-gray-100';
  }

  switch (rating) {
    case 'A':
      return 'text-green-600 bg-green-100';
    case 'B':
      return 'text-brand-600 bg-brand-100';
    case 'C':
      return 'text-yellow-600 bg-yellow-100';
    case 'D':
      return 'text-orange-600 bg-orange-100';
    case 'F':
      return 'text-red-600 bg-red-100';
    default:
      return 'text-gray-600 bg-gray-100';
  }
};

const getPaymentStatusColor = (status: string | undefined) => {
  if (!status) {
    return 'text-gray-600 bg-gray-100';
  }

  switch (status) {
    case 'paid':
      return 'text-green-600 bg-green-100';
    case 'partial':
      return 'text-brand-600 bg-brand-100';
    case 'overdue':
      return 'text-red-600 bg-red-100';
    case 'no_transactions':
      return 'text-gray-600 bg-gray-100';
    default:
      return 'text-gray-600 bg-gray-100';
  }
};

interface CreditInfoStatusSectionProps {
  creditInfo: CreditInfo;
}

export const CreditInfoStatusSection: React.FC<CreditInfoStatusSectionProps> = ({
  creditInfo
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="text-sm font-medium text-gray-700 mb-2">تقييم الدفع</h4>
        <div className="flex items-center gap-3">
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${getRatingColor(creditInfo.paymentRating)}`}>
            {displayValue(creditInfo.paymentRating)}
          </span>
          <span className="text-sm text-gray-600">{displayValue(creditInfo.paymentRatingText)}</span>
        </div>
      </div>

      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="text-sm font-medium text-gray-700 mb-2">حالة الدفع</h4>
        <div className="flex items-center gap-3">
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${getPaymentStatusColor(creditInfo.paymentStatus)}`}>
            {displayValue(creditInfo.paymentStatusText)}
          </span>
        </div>
      </div>
    </div>
  );
};
